import { motion } from 'framer-motion'
import { Crown, Sparkles, Trophy } from 'lucide-react'

import { useCommandDashboard } from '@/contexts/CommandDashboardContext'

export function TodaysWin() {
  const { data } = useCommandDashboard()
  const win = data?.todays_win ?? {}
  const wins = Array.isArray(win.wins) ? win.wins : []
  const summary = win.summary_line ?? 'Tracking today\'s progress'
  const badge = win.status_badge === 'on_track' ? 'On track' : win.status_badge === 'steady' ? 'Steady' : 'Building'

  return (
    <motion.section
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-2xl shadow-luxury-sm"
      style={{
        border: '1px solid hsl(31 53% 64% / 0.18)',
        background:
          'linear-gradient(135deg, hsl(40 45% 97%) 0%, hsl(0 0% 100%) 50%, hsl(31 53% 95% / 0.5) 100%)',
      }}
    >
      <div className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gold/15 blur-2xl" />

      <div className="relative px-4 py-3.5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-gold to-[hsl(31_45%_52%)] text-white shadow-sm">
            <Trophy className="h-4 w-4" strokeWidth={2} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h2 className="text-sm font-bold tracking-tight text-foreground">
                Today&apos;s win
              </h2>
              <Sparkles className="h-3.5 w-3.5 text-gold" />
            </div>
            <p className="text-[11px] text-muted-foreground">{summary}</p>
          </div>
          <div className="hidden items-center gap-1 rounded-full bg-gold/15 px-2.5 py-1 sm:flex">
            <Crown className="h-3 w-3 text-[hsl(31_45%_42%)]" />
            <span className="text-[10px] font-bold text-[hsl(31_45%_38%)]">{badge}</span>
          </div>
        </div>

        {wins.length > 0 ? (
          <div className="mt-3 grid grid-cols-3 gap-2">
            {wins.map((item) => (
              <div
                key={item.label}
                className="rounded-xl bg-white/60 px-2.5 py-2 shadow-sm"
                style={{ border: '1px solid hsl(31 53% 64% / 0.1)' }}
              >
                <p className="text-[9px] font-medium uppercase tracking-wide text-muted-foreground">
                  {item.label}
                </p>
                <p className="mt-0.5 text-sm font-bold tabular-nums leading-tight">{item.value}</p>
                <p className="mt-0.5 text-[10px] leading-snug text-muted-foreground">{item.detail}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="mt-3 text-[11px] text-muted-foreground">Complete sales and appointments to unlock highlights.</p>
        )}
      </div>
    </motion.section>
  )
}
